import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  BasisOfNotice,
  DocumentIssueOrigin,
  DocumentReferenceType,
  ICreateSefObavestenjeCommand,
} from '@kodit/core/data-api';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';

@Injectable({
  providedIn: 'root',
})
export class SefObavestenjeFormService {
  constructor(private _fb: FormBuilderTypeSafe) {}

  public GetSefObavestenjeFormGroup(): FormGroupTypeSafe<ICreateSefObavestenjeCommand> {
    return this._fb.group<ICreateSefObavestenjeCommand>({
      brojObavestenja: new FormControl(null, [Validators.required, Validators.maxLength(64)]),
      ukupanIznosPdv: new FormControl(0, [Validators.required, Validators.min(0.01)]),
      porekeloDokumenta: new FormControl(DocumentIssueOrigin.DOCUMENT_ISSUED_VIA_SEF, Validators.required),
      osnovObavestenja: new FormControl(BasisOfNotice.CREDIT_NOTE_ISSUED, Validators.required),
      tipReferentnogDokumenta: new FormControl(DocumentReferenceType.CREDIT_NOTE_REFERENCE_TO_INVOICE, Validators.required),
      brojReferentnogDokumenta: new FormControl(null, Validators.required),
      datumReferentnogDokumenta: new FormControl(null, Validators.required),
      pocetakPeriodaFakture: new FormControl(null),
      krajPeriodaFakture: new FormControl(null),
      datumStornoReferentnogDokumenta: new FormControl(null),
      napomena: new FormControl(null, Validators.maxLength(2000)),
      pibPrimaoca: new FormControl(null, Validators.required),
      mbPrimaoca: new FormControl(null),
    });
  }
}
